import { render } from "./Balance.vue?vue&type=template&id=c94547fa&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=c94547fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94547fa"]])

export default __exports__